import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';
import styled from 'styled-components';

export const useStyles = (props: { flow: string; fontFamily: string }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      offlineContainer: {
        minWidth: '100%',
        overflow: 'hidden',
        position: 'relative',
        alignItems: 'center',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: props.flow === 'fair' ? 'column' : 'row',
        height: props.flow === 'fair' ? '765px' : '879px',
        justifyContent: props.flow === 'fair' ? 'start' : 'center',
        boxShadow: props.flow === 'fair' ? 'none' : '0 3px 9px 0px rgba(0, 0, 0,0.2)',
        backgroundColor: props.flow === 'fair' ? 'initial' : 'white',
        [theme.breakpoints.down('lg')]: {
          height: props.flow === 'fair' ? '60%' : '1665px',
          flexDirection: 'column'
        },
        [theme.breakpoints.only('lg')]: {
          height: '830px',
          flexDirection: 'row'
        }
      },
      offlineImage: {
        height: '880px',
        [theme.breakpoints.down('lg')]: {
          height: '920px'
        },
        [theme.breakpoints.only('lg')]: {
          height: '830px'
        }
      },
      offlineText: {
        fontSize: '32px',
        textAlign: 'center',
        fontFamily: props.fontFamily,
        textTransform: props.flow === 'fair' ? 'uppercase' : 'none',
        whiteSpace: 'pre-wrap',
        [theme.breakpoints.down('lg')]: {
          fontSize: props.flow === 'fair' ? '36px' : '32px'
        }
      },
      offlineImageBlock: {
        [theme.breakpoints.down('lg')]: {
          width: '100%'
        },
        [theme.breakpoints.only('lg')]: {
          width: '50%'
        }
      },
      offlineTextBlock: {
        alignSelf: 'center',
        [theme.breakpoints.down('lg')]: {
          height: '750px',
          width: '100%'
        },
        [theme.breakpoints.only('lg')]: {
          width: '50%'
        },
        [theme.breakpoints.only('lg')]: {
          height: 'fit-content'
        }
      },
      offlineHeaderText: {
        fontSize: '64px',
        textAlign: 'center',
        fontFamily: props.fontFamily,
        fontWeight: 900,
        margin: '0px',
        lineHeight: '1.25',
        whiteSpace: 'pre-wrap',
        [theme.breakpoints.down('lg')]: {
          padding: '10px 20px 0px 20px'
        }
      },
      offlineTextDivider: {
        flex: 'none',
        height: '30px',
        background: 'transparent'
      },
      offlineImageOnly: {
        width: '1720px',
        height: '890px',
        marginBottom: '8px',
        '&>*>img': {
          height: '100%'
        },
        [theme.breakpoints.down('lg')]: {
          width: '100%',
          height: '1655px'
        },
        [theme.breakpoints.only('lg')]: {
          height: '840px'
        }
      }
    })
  );

export const OfflineViewImage = styled.img`
  width: 100%;
  background-size: cover;
`;
